import React, { useEffect, useContext, useState } from 'react';
import { appContext } from "./../../../AppContext";
import {useFetch} from '../../../utils/hooks/useFetch'
import { Spin, message, Modal, Tabs, Switch, Typography, Alert } from 'antd';
import SkillWikiModal from '../wiki/SkillWikiModal';
import SkillWiki from '../wiki/SkillWiki';
import { skillsToChoseColumns, skillsToChoseList } from '../columns/skillColumns';
import LarpTable from '../../table/LarpTable';
const { TabPane } = Tabs;
const {Text} = Typography

export default function SkillsToChose({
    allRaces,
    newCharacter,
    isModalVisible, 
    setIsModalVisible,
    addSkillToCharacter,
    isStormvloed
}) {

     const [appState] = useContext(appContext);
     const [doFetch, FetchType] = useFetch();
     const[isLoading, setIsLoading] = useState(true)
     const [searchValue, setSearchValue] = useState("");
     const [dataSource, setDataSource] = useState([]);
     const [listSource, setListSource] = useState([])
     const [result, setResult] = useState([])
     const [isViewModalVisible, setIsViewModalVisible] = useState(false);
     const [selectedRecord, setSelectedRecord] = useState({});
     const [closeModalAfterChoosingSkill, setCloseModalAfterChoosingSkill] = useState(false);

     const [allSkills, setAllSkills] = useState([])

     useEffect(() => {
        getAllWiki();
          }, // eslint-disable-next-line
      [appState.storyId])

      function getAllWiki()
      {
          const url = `/api/skill/GetWiki`
          doFetch(url)
          .then((response) => onInventoryLoaded(response.isSuccess, response.result))
  
          function onInventoryLoaded(isSuccess, result) { 
            if(isSuccess) {
                setAllSkills(result);
              return;
            }
            setAllSkills([])
          }
      }

      useEffect(() => {
        if(result.length <= 0) {
          setDataSource([])
          setListSource([])
          return;
        }
        const newDataSource = result.filter(_ => _.name?.toLowerCase().includes(searchValue.toLowerCase())
                                                ||  _.skillPointType?.name?.toLowerCase().includes(searchValue.toLowerCase())
        )
        setDataSource(newDataSource);
        setListSource(skillsToChoseList(newDataSource, appState, onAddClick, onRowClick))
      }, // eslint-disable-next-line
      [result, searchValue])

      useEffect(() => {
        refresh();
          }, // eslint-disable-next-line
      [searchValue, appState.storyId, newCharacter])

      function refresh()
      {
          if(newCharacter.skillPointsLeft === null) {
              return
          }
          const url = `/api/character/GetSkillsToChoseFrom`
          doFetch(url, FetchType.POST, newCharacter)
          .then((response) => onInventoryLoaded(response.isSuccess, response.result))
  
          function onInventoryLoaded(isSuccess, result) { 
            if(isSuccess) {
              setResult(result);
              setIsLoading(false);
              return;
            }
            setResult([])
            message.error('Could not get Skills');
            setIsLoading(false);
          }
      }

      if(isLoading)
      {
          return <Spin />
      }

      function onRowClick(record)
      {
        setSelectedRecord(record);
        setIsViewModalVisible(true);
      }

      function onAddClick(record) {
        if(closeModalAfterChoosingSkill === true) {
          setIsModalVisible(false);
        }
          addSkillToCharacter(record);
      }
      
      const columns = skillsToChoseColumns(appState, onAddClick, onRowClick);

    function handleOk() {
        setIsModalVisible(false);
    }

    function handleCancel() {
        setIsModalVisible(false);
    }

    function skillPointsLeft() {
      return (
        <>
            SkillPoints: {isStormvloed  && "Algemeen: "}{newCharacter?.skillPointsLeft?.algemeen} / {newCharacter?.skillPointsTotal?.algemeen}
            {isStormvloed && <>
            <br />
            Strijd: {newCharacter?.skillPointsLeft?.strijd} / {newCharacter?.skillPointsTotal?.strijd}
            <br />
            Ambacht: {newCharacter?.skillPointsLeft?.ambacht} / {newCharacter?.skillPointsTotal?.ambacht}
            </>}
        </>
      )
    }

    return (
        <Modal 
            title={`Skills to choose from`}  
            visible={isModalVisible} 
            onOk={handleOk} 
            onCancel={handleCancel}
            footer={null}
            width={"80%"}
        >
          <Alert
              message="Skills"
              description="The skills below are the skills you can currently choose (based on their requirements). Select the other tab (Wiki) to see all skills"
              type="warning"
              showIcon
          />
          {skillPointsLeft()}
        <Tabs defaultActiveKey="1">
            <TabPane tab="Skills to Choose" key="1">

              <Text>Close after adding a skill </Text>
              <Switch 
                checked={closeModalAfterChoosingSkill} 
                onChange={() => setCloseModalAfterChoosingSkill(!closeModalAfterChoosingSkill)}
              />
              <br />
              <br />

              <LarpTable 
                columns={columns}
                dataSource={dataSource}
                listSource={listSource}
                onDoubleRowClick={onRowClick}
                refresh={refresh}
                setSearchValue={setSearchValue}
              />

              <SkillWikiModal 
                setIsModalVisible={setIsViewModalVisible}
                isModalVisible={isViewModalVisible}
                record={selectedRecord}
                allSkills={allSkills}
                allRaces={allRaces}
              />     
            </TabPane>  
            <TabPane tab="Wiki" key="2">
                <SkillWiki allSkills={undefined}/>
            </TabPane> 
        </Tabs> 
    </Modal>
    )
}